import React, { useState, useEffect } from "react";
import SocialMedia from "./Socialmedia";
import Bannersection from "./banner";
import TopFooter from "./Topfooter";
import Footer from "./Footer";
import useWindowWidth from "./ScreenwiseCondition";               

const Wrapper = ({
  children,
  showTopFooter = true,
  desktopImage,
  mobileImage,            
  firstTitle,
  bannerHeading,
  bansubheading,
  scrolldown,
  bottomarrow,
  banpara,
  topfootHead,
  topfootPara,        
  bookCall
}) => {
  return (
    <>
      <div className="wrapper-main">
        <div
          className="container-fluid bg"
          style={{ backgroundImage: `url(${useWindowWidth() >= 767 ? desktopImage : mobileImage})`, backgroundPosition: "top center", backgroundRepeat: "no-repeat" }}>
              <Bannersection
                firstTitle={firstTitle}
                bannerHeading={bannerHeading}
                bansubheading={bansubheading}
                scrolldown={scrolldown}
                bottomarrow={bottomarrow}
                banpara={banpara}
              />
              {children}
              {showTopFooter && <TopFooter topfootHead={topfootHead} topfootPara={topfootPara} bookCall={bookCall} />}
              <Footer />
        </div>
      </div>
    </>
  );
};

export default Wrapper;
